var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { row: "", wrap: "" } },
    [
      _c("v-flex", { attrs: { xs12: "", md12: "" } }, [
        _c("div", { staticClass: "pie-wrapper" }, [
          _c("h1", { staticClass: "top-text" }, [_vm._v("Today")]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "pie",
              class: _vm.pieClicked === "Day" ? "pieClicked" : "",
              style: _vm.bggradientDay,
              on: {
                click: function($event) {
                  ;(_vm.bggradient = _vm.bggradientDay),
                    (_vm.wrapper2Text = "Today's Sales"),
                    (_vm.salesOnClick = _vm.sales.today),
                    (_vm.userwiseSales = _vm.userwiseSalesDay),
                    (_vm.sentToCustomersOrders = _vm.sentToCustomersOrdersDay),
                    (_vm.processingOrders = _vm.processingOrdersDay),
                    (_vm.pieClicked = "Day"),
                    (_vm.showDetails = true)
                }
              }
            },
            [
              _c(
                "div",
                { staticClass: "txt" },
                [
                  !_vm.loadingToday
                    ? _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.sentToCustomersOrdersDay +
                              _vm.processingOrdersDay
                          )
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.loadingToday
                    ? _c(
                        "v-layout",
                        { attrs: { "justify-center": "", "align-center": "" } },
                        [
                          _c("v-progress-circular", {
                            attrs: { indeterminate: "", color: "primary" }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "pie-wrapper" }, [
          _c("h1", { staticClass: "top-text" }, [_vm._v("WTD")]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "pie",
              class: _vm.pieClicked === "Week" ? "pieClicked" : "",
              style: _vm.bggradientWeek,
              on: {
                click: function($event) {
                  ;(_vm.bggradient = _vm.bggradientWeek),
                    (_vm.wrapper2Text = "WTD Sales"),
                    (_vm.salesOnClick = _vm.sales.week),
                    (_vm.userwiseSales = _vm.userwiseSalesWeek),
                    (_vm.sentToCustomersOrders = _vm.sentToCustomersOrdersWeek),
                    (_vm.processingOrders = _vm.processingOrdersWeek),
                    (_vm.pieClicked = "Week"),
                    (_vm.showDetails = true)
                }
              }
            },
            [
              _c(
                "div",
                { staticClass: "txt" },
                [
                  !_vm.loadingWeek
                    ? _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.sentToCustomersOrdersWeek +
                              _vm.processingOrdersWeek
                          )
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.loadingWeek
                    ? _c(
                        "v-layout",
                        { attrs: { "justify-center": "", "align-center": "" } },
                        [
                          _c("v-progress-circular", {
                            attrs: { indeterminate: "", color: "primary" }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "pie-wrapper" }, [
          _c("h1", { staticClass: "top-text" }, [_vm._v("MTD")]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "pie",
              class: _vm.pieClicked === "Month" ? "pieClicked" : "",
              style: _vm.bggradientMonth,
              on: {
                click: function($event) {
                  ;(_vm.bggradient = _vm.bggradientMonth),
                    (_vm.wrapper2Text = "MTD Sales"),
                    (_vm.salesOnClick = _vm.sales.month),
                    (_vm.userwiseSales = _vm.userwiseSalesMonth),
                    (_vm.sentToCustomersOrders =
                      _vm.sentToCustomersOrdersMonth),
                    (_vm.processingOrders = _vm.processingOrdersMonth),
                    (_vm.pieClicked = "Month"),
                    (_vm.showDetails = true)
                }
              }
            },
            [
              _c(
                "div",
                { staticClass: "txt" },
                [
                  !_vm.loadingMonth
                    ? _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.sentToCustomersOrdersMonth +
                              _vm.processingOrdersMonth
                          )
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.loadingMonth
                    ? _c(
                        "v-layout",
                        { attrs: { "justify-center": "", "align-center": "" } },
                        [
                          _c("v-progress-circular", {
                            attrs: { indeterminate: "", color: "primary" }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "pie-wrapper" }, [
          _c("h1", { staticClass: "top-text" }, [_vm._v("QTD")]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "pie",
              class: _vm.pieClicked === "Quarter" ? "pieClicked" : "",
              style: _vm.bggradientQuarter,
              on: {
                click: function($event) {
                  ;(_vm.bggradient = _vm.bggradientQuarter),
                    (_vm.wrapper2Text = "QTD Sales"),
                    (_vm.salesOnClick = _vm.sales.quarter),
                    (_vm.userwiseSales = _vm.userwiseSalesQuarter),
                    (_vm.sentToCustomersOrders =
                      _vm.sentToCustomersOrdersQuarter),
                    (_vm.processingOrders = _vm.processingOrdersQuarter),
                    (_vm.pieClicked = "Quarter"),
                    (_vm.showDetails = true)
                }
              }
            },
            [
              _c(
                "div",
                { staticClass: "txt" },
                [
                  !_vm.loadingQuarter
                    ? _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.sentToCustomersOrdersQuarter +
                              _vm.processingOrdersQuarter
                          )
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.loadingQuarter
                    ? _c(
                        "v-layout",
                        { attrs: { "justify-center": "", "align-center": "" } },
                        [
                          _c("v-progress-circular", {
                            attrs: { indeterminate: "", color: "primary" }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "pie-wrapper" }, [
          _c("h1", { staticClass: "top-text" }, [_vm._v("YTD")]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "pie",
              class: _vm.pieClicked === "Year" ? "pieClicked" : "",
              style: _vm.bggradientYear,
              on: {
                click: function($event) {
                  ;(_vm.bggradient = _vm.bggradientYear),
                    (_vm.wrapper2Text = "YTD Sales"),
                    (_vm.salesOnClick = _vm.sales.year),
                    (_vm.userwiseSales = _vm.userwiseSalesYear),
                    (_vm.sentToCustomersOrders = _vm.sentToCustomersOrdersYear),
                    (_vm.processingOrders = _vm.processingOrdersYear),
                    (_vm.pieClicked = "Year"),
                    (_vm.showDetails = true)
                }
              }
            },
            [
              _c(
                "div",
                { staticClass: "txt" },
                [
                  !_vm.loadingYear
                    ? _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.sentToCustomersOrdersYear +
                              _vm.processingOrdersYear
                          )
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.loadingYear
                    ? _c(
                        "v-layout",
                        { attrs: { "justify-center": "", "align-center": "" } },
                        [
                          _c("v-progress-circular", {
                            attrs: { indeterminate: "", color: "primary" }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ]
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-17d6e18a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17d6e18a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SamplesDashboard.vue
// module id = null
// module chunks = 